var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMultiPlatform(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E7E9EF",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.25 14.787a.34.34 0 0 1 .23.108.34.34 0 0 1 .107.23v6.125a.35.35 0 0 1-.337.337h-10.5a.332.332 0 0 1-.338-.337v-6.125a.35.35 0 0 1 .338-.338h10.5zm1.85.338c0-1.012-.838-1.85-1.85-1.85h-10.5c-1.04 0-1.85.839-1.85 1.85v6.125c0 1.04.81 1.85 1.85 1.85h10.5c1.011 0 1.85-.81 1.85-1.85v-6.125zm-1.313-3.281a.765.765 0 0 0-.756-.756H10.97a.748.748 0 0 0-.756.756c0 .438.318.756.756.756H21.03a.748.748 0 0 0 .757-.756zm-1.312-2.188a.765.765 0 0 0-.756-.756H12.28a.748.748 0 0 0-.756.756c0 .438.318.756.756.756h7.438a.748.748 0 0 0 .756-.756z",
    fill: "#233145",
    stroke: "#233145",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultiPlatform);
export default __webpack_public_path__ + "static/media/multi_platform.13163b86c61c5eb9c3f98b9fcdcd7cfd.svg";
export { ForwardRef as ReactComponent };